import ApiServer from '@/utils/api/ApiServer.js'
import { Bid } from '@/model/Bid.js'
import { Outcome } from '@/utils/Enumerations.js'

const inFlightBids = {}

export default {
  fetchBids (context, params) {
    const key = JSON.stringify(params ?? {})
    if (inFlightBids[key]) return inFlightBids[key]
    inFlightBids[key] = ApiServer.get('bids', { params })
      .then(response => {
        const bids = response.data.map(b => new Bid(b))
        context.commit('setBids', bids)
        return bids
      })
      .finally(() => {
        delete inFlightBids[key]
      })
    return inFlightBids[key]
  },
  async fetchBid (context, bidId) {
    const response = await ApiServer.get('bids/' + bidId)
    return new Bid(response.data)
  },
  async fetchBidStatistics (context, params) {
    const response = await ApiServer.get('bids/statistics', { params })
    return response.data
  },
  async fetchBidTractStatistics (context, params) {
    const response = await ApiServer.get('bids/statistics/tracts', { params })
    return response.data
  },
  async fetchBidSupplierStatistics (context, params) {
    const response = await ApiServer.get('bids/statistics/suppliers', { params })
    return response.data
  },
  async fetchWinningBids (context, tractId) {
    const summaries = await ApiServer.get('bids', { params: { tractId, outcome: Outcome.Won.value } })
    const details = await Promise.all(summaries.data.map(b => ApiServer.get('bids/' + b.bidId)))
    return details.map(response => new Bid(response.data))
  },
  async createBid (context, payload) {
    const response = await ApiServer.post('bids', payload)
    return new Bid(response.data)
  },
  async updateBid (context, { bidId, payload }) {
    const response = await ApiServer.put('bids/' + bidId, payload)
    return response.data
  },
  async deleteBid (context, bidId) {
    const response = await ApiServer.delete('bids/' + bidId)
    return response.data
  },
  async createBidProduct (context, { bidId, payload }) {
    const response = await ApiServer.post(`bids/${bidId}/products`, payload)
    return response.data
  },
  async updateBidProduct (context, { bidId, bidProductId, payload }) {
    const response = await ApiServer.put(`bids/${bidId}/products/${bidProductId}`, payload)
    return response.data
  },
  async deleteBidProduct (context, { bidId, bidProductId }) {
    const response = await ApiServer.delete(`bids/${bidId}/products/${bidProductId}`)
    return response.data
  }
}
